import { render, staticRenderFns } from "./ProductsReportPage.vue?vue&type=template&id=0d2a99c3"
import script from "./ProductsReportPage.vue?vue&type=script&lang=js"
export * from "./ProductsReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports